'use strict';

class TabPanel extends Widget {
  _element: any;
  _tabs: any;
  _index: any;

  constructor(element: any) {
    super(element);

    // Default to horizontal tab buttons
    if (!this._element.hasClass('vertical') && !this._element.hasClass('horizontal')) {
      this._element.addClass('horizontal');
    }

    this._tabs = [];
    this._index = 0;
    this._update();
  }

  _update() {
    const buttons = this._element.children('.header').children('.button');
    const tabs = this._element.children('.tab');

    if (buttons.length !== tabs.length) {
      console.log('Tab panel with different amount of buttons and contents');
    }

    this._tabs = [];

    for (let i = 0; i < buttons.length && i < tabs.length; ++i) {
      const button = ui.button($(buttons[i]));
      let tab = ui.tab($(tabs[i]));

      button.on('clicked', this.index.bind(this, i));

      this._tabs.push({
        button: button,
        tab: tab
      });
    }

    buttons[0].click();
  }

  tab(index: any) {
    return this._tabs[index].tab;
  }

  button(index: any) {
    return this._tabs[index].button;
  }

  index(index: any) {
    if (index === undefined) {
      return this._index;
    } else {
      for (let i = 0; i < this._tabs.length; ++i) {
        this._tabs[i].button.active(false);
        this._tabs[i].tab.hide();
      }

      this._index = index;
      this._tabs[index].button.active(true);
      this._tabs[index].tab.show();
    }
  }

  static Create() {
    return $('<div class="tabpanel"><div class="header" /></div>');
  }
}

class Tab extends Widget {
  _element: any;

  constructor(element: any) {
    super(element);
  }

  static Create() {
    return $('<div class="tab" />');
  }
}

ui.TabPanel = TabPanel;
ui.Tab = Tab;
ui.tabpanel = ui.widgetConstructor('tabpanel', ui.TabPanel);
ui.tab = ui.widgetConstructor('tab', ui.Tab);
